/* Click-to-play for the review cards and the demo section.

   Nothing about the video exists in the DOM until the visitor presses play -
   the card only carries a data-src - so video never touches the LCP path.

   Why the element is BUILT here rather than cloned out of a <template>:
   a <video> cloned from template content arrives already in
   NETWORK_NO_SOURCE, so it sits at readyState 0 and never fetches. That is
   what made playback wait until the scrubber was dragged. A video created
   with createElement and given a .src loads normally.

   No custom buffering state. An earlier version held our own play button on
   screen with a spinner until the 'playing' event fired - which meant that if
   playback never started, the visitor was left staring at a spinner with the
   button disabled and no way to retry. Instead the native poster attribute
   covers the frame (so it never flashes black) and the browser's own controls
   report buffering. Fewer states, no dead ends. */
(function(){
  'use strict';

  function mount(wrap){
    if(!wrap || wrap.copPlayer) return;

    var embed = wrap.getAttribute('data-embed');
    if(embed){
      var f = document.createElement('iframe');
      f.className = 'cop-vid';
      f.src = embed;
      f.setAttribute('title', 'Video');
      f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
      f.setAttribute('allowfullscreen', '');
      wrap.appendChild(f);
      wrap.classList.add('playing');
      wrap.copPlayer = f;
      return;
    }

    var src = wrap.getAttribute('data-src');
    if(!src) return;

    var v = document.createElement('video');
    v.className = 'cop-vid';
    v.controls = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    v.setAttribute('preload', 'auto');

    /* Native poster = the same still the card was already showing, so the
       frame never goes black while the file buffers. */
    var poster = wrap.querySelector('img');
    if(poster) v.poster = poster.currentSrc || poster.src;

    wrap.appendChild(v);
    v.src = src;
    wrap.classList.add('playing');
    wrap.copPlayer = v;
  }

  function play(wrap){
    var v = wrap && wrap.copPlayer;
    if(!v || v.tagName !== 'VIDEO') return;
    var p = v.play();
    if(p && p.catch){
      p.catch(function(){
        /* Sound-on playback refused - fall back to muted so it still moves.
           If that is refused too, the native controls are right there. */
        if(!v.muted){
          v.muted = true;
          var q = v.play();
          if(q && q.catch) q.catch(function(){});
        }
      });
    }
  }

  /* Start the download on press, play on release - the fetch is already in
     flight by the time the click lands. */
  document.addEventListener('pointerdown', function(e){
    var btn = e.target.closest && e.target.closest('.im .play');
    if(btn) mount(btn.closest('.im'));
  }, true);

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.im .play');
    if(!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.im');
    mount(wrap);
    play(wrap);
  });
})();
